// extracted by mini-css-extract-plugin
export default {"chooseQuantity":"Quontity_chooseQuantity__M1fWL"};